import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import {
  EditorialMarquee, Services, Manifesto, Pricing, ServiceArea, Reviews,
} from "@/components/site/Sections";
import { Gallery } from "@/components/site/Gallery";
import { BookingForm } from "@/components/site/BookingForm";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="w-full overflow-x-hidden bg-background" data-testid="landing-page">
      <Nav />
      <Hero />
      <EditorialMarquee />
      <Services />
      <Manifesto />
      <Pricing />
      <ServiceArea />
      <Gallery />
      <Reviews />
      <BookingForm />
      <Footer />
    </div>
  );
}
